import { render, staticRenderFns } from "./EDataTable.vue?vue&type=template&id=ecc18942&scoped=true&"
import script from "./EDataTable.vue?vue&type=script&lang=js&"
export * from "./EDataTable.vue?vue&type=script&lang=js&"
import style0 from "./EDataTable.vue?vue&type=style&index=0&id=ecc18942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc18942",
  null
  
)

export default component.exports